function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'dark-brown': 'rgb(142, 59, 41)','brick-red': 'rgb(207, 70, 32)','light-green': 'rgb(169, 201, 179)','turquoise': 'rgb(65, 153, 166)','dark-blue': 'rgb(27, 49, 94)','grass-green': 'rgb(137, 188, 89)','earth-black': 'rgb(52, 49, 44)','pesto-green': 'rgb(59, 68, 30)','powerful-violet': 'rgb(95, 64, 98)','arctic-dawn': 'rgb(255, 68, 3)','baltic-blue': 'rgb(0, 33, 255)','sahara-pink': 'rgb(209, 0, 96)','azure-sky': 'rgb(204, 225, 238)',};

    this.images = {'ebi': 'url("//www.ebibike.com/cdn/shop/files/b_68x.png?v=13708130029116918344")','for-rider-165-172cm': 'url("//www.ebibike.com/cdn/shop/files/2XS_68x.png?v=749016496320969365")','for-rider-170-178cm': 'url("//www.ebibike.com/cdn/shop/files/XS_68x.png?v=8356219027962890046")','for-rider-176-184cm': 'url("//www.ebibike.com/cdn/shop/files/S_68x.png?v=8037077211858121945")',};

    this.triggers = ['color','colour','couleur','farbe','cor','size',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
